import React, { ChangeEvent } from "react";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import IOrder_ItemUI from "../../../models/IOrder_ItemUI";
import IPrice_Group from "../../../models/IPrice_Group";
import { FormattedNumber } from "react-intl";
import styled from "styled-components";
import { NumericFormat } from "react-number-format";

type Props = {
    row: IOrder_ItemUI;
    updatePriceGroupRowFn: (priceGroupId: number, row: IOrder_ItemUI) => void;
    priceGroups: IPrice_Group[];
};

export const OrderItemPriceGroupSelect = (props: Props) => {
    const [updatePriceGroupId, setUpdatePriceGroupId] = React.useState<number | null>(null);
    const [updatePriceGroupValue, setUpdatePriceGroupValue] = React.useState<IPrice_Group | null>(null);

    const handlePriceGroupChange = (e: ChangeEvent<any>) => {
        const priceGroupId = parseInt(e.target.value);
        setUpdatePriceGroupId(priceGroupId);

        if (props.row.Catalog_Item) {
            const priceGroup = props.priceGroups.find((pg) => pg.id === priceGroupId);
            if (priceGroup) {
                setUpdatePriceGroupValue(priceGroup);
            }
        }

        props.updatePriceGroupRowFn(priceGroupId, props.row);
    };

    return (
        <div className={"OrderItemPriceGroupSelect"}>
            <div>
                <OwSelectOption
                    fn={handlePriceGroupChange}
                    titleProp={"value"}
                    valueProp={"id"}
                    name={"price_group_id"}
                    options={props.priceGroups}
                    selectedOption={props.row}
                    selectedOptionProp={"price_group_id"}
                />
            </div>
            {updatePriceGroupId && updatePriceGroupValue ? (
                <NumberWrapper>
                    <NumericFormat
                        value={props.row?.Catalog_Item?.pricing[updatePriceGroupValue.value]}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                    />
                    {/*<FormattedNumber*/}
                    {/*    value={props.row?.Catalog_Item?.pricing[updatePriceGroupValue.value]}*/}
                    {/*    currency={"USD"}*/}
                    {/*    minimumSignificantDigits={2}*/}
                    {/*    currencySign={"standard"}*/}
                    {/*/>*/}
                </NumberWrapper>
            ) : null}
        </div>
    );
};

const NumberWrapper = styled.div`
    padding: 0.25rem 0.5rem;
`;
